export interface ShouldShowSuggestedPriceColumnParams {
  isInformation: boolean;
  isPriceUpdate: boolean;
  showSuggestedPricePerUnitColumn: boolean;
  suggestedPriceEnhancementPhase: number;
  useSuggestedPricing: boolean;
}

// Single source of truth for when the Suggested Price column appears — used by the buyer HoT
// column builder and the Excel export column builder so their gates cannot drift.
// The XLSX *import* gate is intentionally different and lives in
// shouldAcceptSuggestedPriceImportColumn — it drops the showSuggestedPricePerUnitColumn
// condition. Do not consolidate the two.
// All five conditions must hold:
//   - suggestedPriceEnhancementPhase >= 1 (LaunchDarkly phased flag)
//   - useSuggestedPricing (drawer kill switch, wired from !request.anchor_pricing_disabled)
//   - showSuggestedPricePerUnitColumn (buyer-only visibility toggle, request.ui_config.lots.show_suggested_price_column)
//   - !isPriceUpdate (price-update events collapse to the single Current Agreed Price column)
//   - !isInformation (RFIs collect information rather than pricing, and the line-item settings
//     drawer already hides the Suggested Price toggle for them, so the column must not render
//     when a stale ui_config still carries show_suggested_price_column)
export const shouldShowSuggestedPricePerUnitColumn = ({
  isInformation,
  isPriceUpdate,
  showSuggestedPricePerUnitColumn,
  suggestedPriceEnhancementPhase,
  useSuggestedPricing,
}: ShouldShowSuggestedPriceColumnParams): boolean => (
  suggestedPriceEnhancementPhase >= 1
    && useSuggestedPricing
    && showSuggestedPricePerUnitColumn
    && !isPriceUpdate
    && !isInformation
);
